// src/ui/styles/modal.css.js
//
// Soft Midnight Glass — Modal Styles
// ----------------------------------
// Provides a premium modal dialog with:
//   - dimmed backdrop
//   - centered glass panel
//   - smooth fade/scale transitions
//   - clean button layout

import {css} from 'lit';

export const modalStyles = css`
  :host {
    display: block;
  }

  /* ------------------------------------------------------------
     Backdrop
  ------------------------------------------------------------ */
  .backdrop {
    position: fixed;
    inset: 0;

    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(4px);

    display: flex;
    align-items: center;
    justify-content: center;

    opacity: 0;
    pointer-events: none;

    transition: opacity var(--transition-slow);
    z-index: 1000;
  }

  .backdrop.open {
    opacity: 1;
    pointer-events: auto;
  }

  /* ------------------------------------------------------------
     Modal panel
  ------------------------------------------------------------ */
  .modal {
    background: var(--glass-bg-heavy);
    border: 1px solid var(--glass-border-strong);
    border-radius: var(--glass-radius-lg);
    box-shadow: var(--glass-shadow-lg);
    backdrop-filter: var(--glass-backdrop);

    padding: 24px 28px;
    width: 360px;
    max-width: 90%;

    color: #fff;
    text-align: center;

    transform: scale(0.92);
    opacity: 0;
    transition:
      transform var(--transition-slow),
      opacity var(--transition-slow);
  }

  .backdrop.open .modal {
    transform: scale(1);
    opacity: 1;
  }

  /* ------------------------------------------------------------
     Title + message
  ------------------------------------------------------------ */
  .title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .message {
    font-size: 15px;
    opacity: 0.85;
    margin-bottom: 22px;
  }

  /* ------------------------------------------------------------
     Buttons
  ------------------------------------------------------------ */
  .buttons {
    display: flex;
    justify-content: center;
    gap: 12px;
  }

  .btn {
    cursor: pointer;
    padding: 8px 16px;

    border-radius: var(--glass-radius);
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);

    color: #fff;
    font-size: 14px;

    transition:
      background var(--transition-fast),
      border-color var(--transition-fast),
      transform var(--transition-fast);
  }

  .btn:hover {
    background: rgba(35, 35, 40, 0.65);
    border-color: var(--glass-border-strong);
  }

  .btn:active {
    transform: scale(0.96);
  }

  .btn.primary {
    background: var(--accent-soft);
    border-color: var(--accent);
    color: var(--accent);
  }

  .btn.primary:hover {
    background: rgba(77, 163, 255, 0.35);
  }
`;